


































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { claimService } from '@/services/claim.services';
import { ClaimComment } from '../stores/claim/types';
import Paginator from '@/components/Paginator.vue';
import { DashboardCommentRemindersPaginator, Reminder } from '../stores/dashboard/types';
import { PaginatorEvent, Comment } from '../types';
import NewCommentModal from '@/components/modals/NewCommentModal.vue';
import { User } from '../stores/authentication/types';

const namespace: string = 'dashboard';

@Component({
    components: {
        Paginator,
        NewCommentModal,
    },
})
export default class DashboardView extends Vue {
    @Action('getReminders', { namespace }) getClaimReminders: any;
    @Action('getUsers', { namespace }) getUsers: any;
    @Action('postReminder', { namespace }) postReminderData: any;
    @Getter('reminders', { namespace }) claimReminders!: DashboardCommentRemindersPaginator;
    @Getter('remindersLoading', { namespace }) getRemindersLoading!: boolean;
    @Getter('users', { namespace }) getUsersData!: User[];
    @Getter('user', { namespace: 'authentication' }) getCurrentUser!: User;

    reminderFields: any = [
        {
            key: 'reminder',
            label: 'Reminder',
            sortable: true,
        },
        {
            key: 'comment',
            label: 'Comment',
            sortable: true,
        },
        {
            label: 'Defender',
            sortable: true,
            key: 'claim.defender.name',
        },
        {
            label: 'Assignee',
            key: 'assignee.name',
            sortable: true,
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    filterData: any = {
        currentRemindersPage: 1,
        remindersPerPage: 10,
        remindersSortBy: '',
        remindersSortDesc: true,
        futureReminders: false,
        assignee: '',
    };


    editComment: Reminder = {
      comment: '',
    };

    @Watch('filterData', { deep: true})
    onPropertyChanged() {
        this.updateRouteQuery();
        this.updateReminders();
    }

    updateRouteQuery() {
        this.$router.push({
            query: {
                currentRemindersPage: this.filterData.currentRemindersPage,
                remindersPerPage: this.filterData.remindersPerPage,
                remindersSortBy: this.filterData.remindersSortBy,
                remindersSortDesc: this.filterData.remindersSortDesc.toString(),
                assignee: this.filterData.assignee,
                futureReminders: this.filterData.futureReminders,
            },
        });
    }

    @Watch('users')
    onUsersLoad() {
        this.filterData.assignee = this.filterData.assignee || this.user || '';
    }

    created() {
        const tmpCurrentRemindersPage = this.$route.query.currentRemindersPage || 1;
        const tmpRemindersPerPage = this.$route.query.remindersPerPage || 10;
        const tmpRemindersSortBy = (Array.isArray(this.$route.query.remindersSortBy) ?
                this.$route.query.remindersSortBy[0] :
                this.$route.query.remindersSortBy) || '' ;
        const tmpRemindersSortDesc = Array.isArray(this.$route.query.remindersSortDesc) ?
                this.$route.query.remindersSortDesc[0] === 'true' :
                this.$route.query.remindersSortDesc === 'true';
        const tmpAssignee = this.$route.query.assignee || '';
        const tmpFutureReminders = Array.isArray(this.$route.query.futureReminders) ?
                this.$route.query.futureReminders[0] === 'true' :
                this.$route.query.futureReminders === 'true';
        this.filterData = {
            currentRemindersPage: tmpCurrentRemindersPage,
            remindersPerPage: tmpRemindersPerPage,
            remindersSortBy: tmpRemindersSortBy,
            remindersSortDesc: tmpRemindersSortDesc,
            futureReminders: tmpFutureReminders,
            assignee: tmpAssignee,
        };
    }

    mounted() {
        this.updateReminders();
    }

    get reminders() {
        return this.claimReminders;
    }

    get remindersData() {
        return this.claimReminders && this.claimReminders.data;
    }

    get remindersPages() {
        return this.claimReminders && this.claimReminders.metadata;
    }

    get remindersLoading() {
        return this.getRemindersLoading;
    }

    onRowClicked(item: any, index: number, event: Event) {
        this.$router.push({ name: 'claim', params: { id: item.claim.id } });
    }

    get users() {
        return this.getUsersData && this.getUsersData.map((val) => {
            return {
                value: val.id,
                text: val.name,
            };
        });
    }

    get user() {
        return this.getCurrentUser && this.getCurrentUser.id;
    }

    updateReminders() {
        this.getClaimReminders({
            page: this.filterData.currentRemindersPage,
            perPage: this.filterData.remindersPerPage,
            sortBy: this.filterData.remindersSortBy,
            sortDesc: this.filterData.remindersSortDesc,
            futureReminders: this.filterData.futureReminders,
            assignee: this.filterData.assignee,
        });
        this.getUsers();
    }

    updateReminderPaginate(paginatorObject: PaginatorEvent) {
        this.filterData.remindersPerPage = paginatorObject.perPage;
        this.filterData.currentRemindersPage = paginatorObject.currentPage;
        this.updateReminders();
    }

    openEditReminderModal(id: number) {
        this.editComment = this.reminders.data[id];
        this.$nextTick(() => {
            ((this.$refs.newCommentModalRef) as any).showModal();
        });
    }

    saveNewComment(comment: Comment) {
        this.postReminderData({
            comment,
            page: this.filterData.currentRemindersPage,
            perPage: this.filterData.remindersPerPage,
            sortBy: this.filterData.remindersSortBy,
            sortDesc: this.filterData.remindersSortDesc,
        });
    }

    setFirstPage() {
        this.filterData.currentRemindersPage = 1;
    }

}
